var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteMediaCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0ZM17.8839 15.15C18.1113 15.3774 18.1113 15.7452 17.8839 15.9726L15.9677 17.8839C15.7403 18.1113 15.3726 18.1113 15.1452 17.8839L12 14.7097L8.85 17.8839C8.62258 18.1113 8.25484 18.1113 8.02742 17.8839L6.11613 15.9677C5.88871 15.7403 5.88871 15.3726 6.11613 15.1452L9.29032 12L6.11613 8.85C5.88871 8.62258 5.88871 8.25484 6.11613 8.02742L8.03226 6.11129C8.25968 5.88387 8.62742 5.88387 8.85484 6.11129L12 9.29032L15.15 6.11613C15.3774 5.88871 15.7452 5.88871 15.9726 6.11613L17.8887 8.03226C18.1161 8.25968 18.1161 8.62742 17.8887 8.85484L14.7097 12L17.8839 15.15Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteMediaCross);
export default __webpack_public_path__ + "static/media/delete-media-cross.a3dad66fdd163ac00ef6c113ec1d567c.svg";
export { ForwardRef as ReactComponent };